import React, { useEffect, useState, useRef } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import MasterViewController from "../../redux/actions/masterApiActions";
import DepartmentFormModal from "./AddDepartment";
import ExportButton from "../../components/ag grid/ExportButton";
import ReusableGrid from "../../components/ag grid/ReusableGrid";

import "../../styles/styles.css";
import "../../styles/layout.css";

const DepartmentList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [editDepartment, setEditDepartment] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const { getDepartments, deleteDepartment } = MasterViewController();
  const { departments } = useSelector((state) => state.master);

  useEffect(() => {
    dispatch(getDepartments());
  }, [dispatch]);

  const handleDelete = (id) => dispatch(deleteDepartment(id));
  const handleEdit = (department) => {
    setEditDepartment(department);
    setShowModal(true);
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80,
    },
    {
      headerName: "Department Name",
      field: "name",
      flex: 1,
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => handleEdit(params.data)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex  mb-3" style={{ justifyContent: "space-between" }}>
        <div>
          {selectedRows.length > 0 && (
            <ExportButton
              gridRef={gridRef}
              fileName="departments.xlsx"
              exportColumns={["name"]}
            />
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <PageSizeSelector
          pageSize={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
        />
        <div className="mt-2">
        <Button
          variant="contained"
          startIcon={<AddCircleOutline />}
          onClick={() => {
            setEditDepartment(null);
            setShowModal(true);
          }}
          sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",             
              fontSize: "0.875rem",       
                       
            }}
        >
          Add Department
        </Button>
        </div>
      </div>
      </div>

      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Department List</h3>
          </Col>
        </Row>
      </div>

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={departments}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <DepartmentFormModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editDepartment}
      />
    </div>
  );
};

export default DepartmentList;











// import React, { useEffect, useState } from "react";
// import "../../styles/styles.css";
// import "../../styles/layout.css";

// import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
// import Table from "react-bootstrap/Table";
// import { Button } from "@mui/material";
// import { Form, Container, Row, Col, Modal } from "react-bootstrap";
// import * as Yup from "yup"; 
// import { useFormik } from "formik";
// import MasterViewController from "../../redux/actions/masterApiActions";
// import { useDispatch, useSelector } from "react-redux";

// const Designations = () => {
//   const [showModal, setShowModal] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const { getDesignations, addDesignation, updateDesignation,  deleteDesignation } = MasterViewController();
//   const { designations } = useSelector((state) => state.master);

//   const dispatch = useDispatch();
//   useEffect(() => {
//     dispatch(getDesignations());
//   }, []);
//   console.log("designations", designations);

//   const validationSchema = Yup.object({
//     name: Yup.string().required("Designation Name is required")
//   });
//   const formik = useFormik({
//     initialValues: {
//       name: ""
//     },
//     validationSchema,
//     onSubmit: (values) => {
//       if (selectedEmployee) {
//         // If editing, call updateRole action
//         dispatch(updateDesignation(selectedEmployee.id, values));
//       } else {
//         // Otherwise, add new role
//         dispatch(addDesignation(values));
//       }
//       setShowModal(false);
//       setSelectedEmployee(null); // Reset after saving
//     }
//   });

//   const handleCloseModal = () => {
//     setShowModal(false);
//     formik.resetForm(); 
//     setSelectedEmployee(null);
//   };
//   const handleEdit = (designations) => {
//     setSelectedEmployee(designations);
//     formik.setValues({
//       name: designations.name
//     });
//     setShowModal(true);
//   };

//   const handleDelete = (designationId) => {
      
//     dispatch(deleteDesignation(designationId));
  
//   };




//   return (
//     <div>
//       <div className="d-flex justify-content-end mb-3">
//         <Button
//           variant="contained"
//           startIcon={<AddCircleOutline />}
//           onClick={() => setShowModal(true)}
//         >
//           Add Designation
//         </Button>
//       </div>

//       <div>
//         <div className="label-card">
//           <Row className="justify-content-between w-100">
//             <Col>
//               <h3>Designations List</h3>
//             </Col>
//           </Row>
//         </div>
//         <Table striped bordered hover responsive="sm">
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Name</th>

//               <th></th>
//             </tr>
//           </thead>
//           <tbody>
//             {designations?.map((employee) => {
//               return (
//                 <tr key={employee.id}>
//                   <td>{employee.id}</td>
//                   <td>{employee.name}</td>
//                   <td className="d-flex justify-content-evenly">
//                     <Edit onClick={() => handleEdit(employee)} /> <Delete onClick={() => handleDelete(employee.id)}/>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </Table>
//       </div>

//       <Modal show={showModal} onHide={() => handleCloseModal()} centered>
//         <Modal.Header closeButton>
//           <Modal.Title className="d-flex align-items-center">
//             Add New Designation
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Container>
//             <Form onSubmit={formik.handleSubmit}>
//               <Form.Group controlId="name">
//                 <Form.Label className="form-label">Designation Name *</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="name"
//                   value={formik.values.name}
//                   onChange={formik.handleChange}
//                   isInvalid={
//                     formik.touched.name && formik.errors.name
//                   }
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.name}
//                 </Form.Control.Feedback>
//               </Form.Group>

//               <Button type="submit" variant="contained" className="mt-3">
//                 Submit
//               </Button>
//             </Form>
//           </Container>
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// };

// export default Designations;
